import GenericModal from 'components/UI/V3/Modals/GenericModal';
import styles from './EditMembershipNameModal.module.scss';
import { FunctionComponent, useState, useEffect } from 'react';
import Button from 'components/UI/V3/Button/Button';
import { Input } from 'components/UI/V3/Forms/Input/Input';

interface EditMembershipNameModalProps {
    currentName: string;
    onSave: (newName: string) => void;
    onCancel: () => void;
    isLoading?: boolean;
}

const EditMembershipNameModal: FunctionComponent<EditMembershipNameModalProps> = props => {
    const [name, setName] = useState(props.currentName);
    const [error, setError] = useState('');
    const loading = props.isLoading || false;

    useEffect(() => {
        setName(props.currentName);
    }, [props.currentName]);

    const validateName = (value: string): boolean => {
        if (value.trim().length === 0) {
            setError('Membership name is required');
            return false;
        }
        setError('');
        return true;
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setName(value);
        if (error) {
            validateName(value);
        }
    };

    const handleSave = () => {
        if (!validateName(name)) {
            return;
        }

        if (name.trim() === props.currentName.trim()) {
            props.onCancel();
            return;
        }

        props.onSave(name.trim());
    };

    const handleEnterPressed = () => {
        if (!loading) {
            handleSave();
        }
    };

    return (
        <GenericModal
            footer={
                <div className={styles.footer}>
                    <Button
                        size="large"
                        className={styles.button}
                        label="Cancel"
                        onClick={props.onCancel}
                        variant="black"
                        disabled={loading}
                    />
                    <Button
                        size="large"
                        className={styles.button}
                        label="Save"
                        onClick={handleSave}
                        variant="green"
                        isLoading={loading}
                        disabled={loading || !!error || name.trim().length === 0}
                    />
                </div>
            }
            onClose={props.onCancel}
            className={styles.modal}
        >
            <div className={styles.content}>
                <span className={styles.title}>Edit Membership Name</span>
                <span className={styles.description}>
                    Update the name of your membership. This will not affect existing enrollments.
                </span>
                <Input
                    id="membership-name"
                    label="Membership Name"
                    value={name}
                    onChange={handleNameChange}
                    onEnterPressed={handleEnterPressed}
                    error={error}
                    disabled={loading}
                    autoFocus
                    maxLength={100}
                    placeholder="Enter membership name"
                />
            </div>
        </GenericModal>
    );
};

export default EditMembershipNameModal;
